import { useEffect, useState } from "react";
import Navigation from "@/components/landing/Navigation";
import Hero from "@/components/landing/Hero";
import AcknowledgementBar from "@/components/landing/AcknowledgementBar";
import FoodSecurityGap from "@/components/landing/FoodSecurityGap";
import PullQuote from "@/components/landing/PullQuote";
import ShockRisk from "@/components/landing/ShockRisk";
import LocalFoodSystems from "@/components/landing/LocalFoodSystems";
import OrchardsTeaser from "@/components/landing/OrchardsTeaser";
import Approach from "@/components/landing/Approach";
import MobileUnit from "@/components/landing/MobileUnit";
import SystemDiagram from "@/components/landing/SystemDiagram";
import WhatWeHaveLearned from "@/components/landing/WhatWeHaveLearned";
import Impact from "@/components/landing/Impact";
import Quote from "@/components/landing/Quote";
import GetInvolved from "@/components/landing/GetInvolved";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <main data-testid="landing-page" className="relative bg-sand text-charcoal">
      <Navigation scrolled={scrolled} />
      <Hero />
      <AcknowledgementBar />
      <FoodSecurityGap />
      <PullQuote />
      <ShockRisk />
      <LocalFoodSystems />
      <OrchardsTeaser />
      <Approach />
      <MobileUnit />
      <SystemDiagram />
      <WhatWeHaveLearned />
      <Impact />
      <Quote />
      <GetInvolved />
      <Contact />
      <Footer />
    </main>
  );
}
